import { Column } from 'src/app/model/common/column';

export const MUSTER_LIST_TABLE_DEFINITION: Column[] = [
  {
    field: 'name',
    header: 'OPMONITORING.LABEL.VISITOR_NAME',
    mobileHeader: 'OPMONITORING.LABEL.VISITOR_NAME',
    formatPattern: 'text',
    type: 'input',
    width: '14%',
    sortable: true,
    filterable: true,
    matchMode: 'contains',
  },
  {
    field: 'contactNumber',
    header: 'CONTACT.LABEL.CONTACT_NUMBER',
    mobileHeader: 'CONTACT.LABEL.CONTACT_NUMBER',
    formatPattern: 'text',
    type: 'input',
    width: '14%',
    sortable: true,
    filterable: true,
    matchMode: 'contains',
  },
  {
    field: 'company',
    header: 'LOCATION.LABEL.COMPANY',
    mobileHeader: 'LOCATION.LABEL.COMPANY',
    formatPattern: 'text',
    type: 'input',
    width: '14%',
    sortable: true,
    filterable: true,
    matchMode: 'contains',
  },
  {
    field: 'facilityName',
    header: 'LOCATION.LABEL.FACILITY_NAME',
    mobileHeader: 'LOCATION.LABEL.FACILITY_NAME',
    formatPattern: 'text',
    type: 'input',
    width: '14%',
    sortable: true,
    filterable: true,
    matchMode: 'contains',
  },
  {
    field: 'areaName',
    header: 'LOCATION.LABEL.AREA',
    mobileHeader: 'LOCATION.LABEL.AREA',
    formatPattern: 'text',
    type: 'input',
    width: '14%',
    sortable: true,
    filterable: true,
    matchMode: 'contains',
  },
  {
    field: 'signInTime',
    header: 'OPMONITORING.LABEL.SIGN_IN_TIME',
    mobileHeader: 'OPMONITORING.LABEL.SIGN_+IN_TIME',
    formatPattern: 'text',
    type: 'input',
    width: '14%',
    sortable: true,
    filterable: true,
    matchMode: 'contains',
  },
  {
    field: 'signOutTime',
    header: 'OPMONITORING.LABEL.SIGN_OUT_TIME',
    mobileHeader: 'OPMONITORING.LABEL.SIGN_OUT_TIME',
    formatPattern: 'text',
    type: 'input',
    width: '14%',
    sortable: true,
    filterable: true,
    matchMode: 'contains',
  },
];
